"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.copy = copy;
const utils_1 = require("@aws-amplify/core/internals/utils");
const copy_1 = require("./internal/copy");
// Overload signatures above are the public contract; the impl is intentionally untyped and shape is enforced by resolveCtxArgs.
function copy(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    return (0, copy_1.copy)(ctx, input);
}
